import type {LoaderFunctionArgs} from 'react-router'
import {redirect, useLoaderData} from 'react-router-dom'

import Context from '@s-ui/react-context'

import {getNavigationState} from '../../helpers/navigationStateCache.ts'
import {withThirdPartiesParam} from '../../hocs/withThirdPartiesParam.js'
import {getInitialProps} from './getInitialProps'
import TechnicalDetailsHomeComponentRaw from './index.js'

// Import styles
import './styles/index.scss'
// HOC wrapping that used to live in `./index.js`. Moved here so `./index.js`
// exports the raw component and receives Fast Refresh in dev.
const TechnicalDetailsHomeComponent = withThirdPartiesParam(Context.wrapper(TechnicalDetailsHomeComponentRaw))

export async function loader({context, request}: LoaderFunctionArgs) {
  const url = new URL(request.url)
  const pathname = url.pathname
  const query = Object.fromEntries(url.searchParams.entries())

  // Build routeInfo compatible with getInitialProps
  const routeInfo = {
    location: {
      pathname,
      query,
      search: url.search,
      state: getNavigationState(pathname)
    },
    params: {}
  }

  // Call existing getInitialProps
  const data = await getInitialProps({routeInfo, context})

  // Legacy `__HTTP__` redirect convention: nothing reads it under RR7, so without this the
  // component would receive it as a prop and call router.push() during render.
  const redirectTo: unknown = data?.__HTTP__?.redirectTo
  if (typeof redirectTo === 'string' && redirectTo !== '') {
    return redirect(redirectTo)
  }

  return data
}

export function Component() {
  const data = useLoaderData()
  return <TechnicalDetailsHomeComponent {...data} />
}
